<!-- Loading bar -->
<fuse-loading-bar />

<!-- Navigation -->

<!-- Wrapper -->
<div class="w-full">
  <router-outlet />
</div>

<!-- Quick chat -->
<!-- <quick-chat #quickChat="quickChat"></quick-chat> -->
